import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const InvisibleImg = styled.img`
  display: none;
`;

type Props = {
  src?: string | null;
  fallback: React.ReactElement;
  children: React.ReactElement;
};

const ImageWithFallback = ({ fallback, src, children }: Props) => {
  const [hasImageError, setHasImageError] = useState(false);

  // Reset the error state when the logoUrl changes
  useEffect(() => {
    setHasImageError(false);
  }, [src]);

  if (src && !hasImageError) {
    return (
      <>
        {children}
        {/*
          Add an invisible img tag just to use the onError listener.
          This will help us fall back to the fallback component if the image fails to load (e.g. 404 error).
        */}
        <InvisibleImg src={src} onError={() => setHasImageError(true)} aria-hidden="true" alt="" />
      </>
    );
  }

  return fallback;
};

export default ImageWithFallback;
